<template>
    <div class="lazy-cont" >
        <div class="lazy-load abs-center" >
            <div class="doctor-ani t-c" >
                <img class="doctor" :src="_global.assetsRoot + '/common/loading_icon.png'" />
                <img class="point" :src="_global.assetsRoot + '/bingo_point.png'" />
            </div>
            <div class="progress-bar" >
                <div ref="progress" class="progress" :style="progressStyle" ></div>
            </div>
            <div class="progress-text t-c" >
                <span class="segoe fs-1-6" >{{ percent }}%&nbsp;&nbsp;{{ $t("message.loading") }}...</span>
            </div>
        </div>
    </div>
</template>

<script>
import assets from '../assets/AssetsConfig.js'
export default {
    data() {
        return {
            percent: 0
        }
    },
    mounted() {
        this.loadResources();
    },
    computed: {
        progressStyle() {return `width: ${this.percent}%;`}
    },
    methods: {
        loadResources() {
            //console.log(this._global.products)
            let lazy = assets.lazy;
            let list = [].concat(lazy.resources).concat(this.isMobile ? lazy.mobile: lazy.web).concat(this._global.poAssets);
            this._global.products.bundles && this._global.products.bundles.map((bd) => {
                list.push(bd.art);
            })

            this.loadImage(list, () => {
                setTimeout(() => {
                    this.$router.replace("/products");
                }, 300)
            })
        },
        loadImage(list, callback) {
            if (list.length === 0) {
                callback && callback();
                return;
            }
            let total = list.length, loaded = 0;
            list.map((i) => {
                let image = new Image();
                image.onload = () => {
                    loaded++;
                    this.percent = Math.round(loaded / total * 100);
                    if (loaded === total) {
                        callback && callback();
                    }
                };
                image.src = /https/.test(i) ? i: (this._global.assetsRoot + "/" + i);
            })
        }
    }
}
</script>

<style lang="scss" >
@import "../assets/css/variables.scss";
.lazy-cont {
    height: 100%;
    background: url($assetRoot + "/desktop/web_pc_bg.png") center no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .lazy-load {

        .doctor-ani {
            position: relative;
            min-height: 33.5rem;

            .doctor {
                width: 40rem;
            }

            .point {
                position: absolute;
                width: 5rem;
                left: 11.5rem;
                top: 18rem;
                animation: pointAnimation linear infinite 1.5s;
                -webkit-animation: pointAnimation linear infinite 1.5s;
            }
        }

        .progress-bar {
            width: 43rem;
            height: 1.8rem;
            margin: 1rem auto;
            padding: .4rem .5rem;
            background: url($assetRoot + "/progress_bar_bg.png") center no-repeat;
            background-size: 100% 100%;
            overflow: hidden;

            .progress {
                width: 0;
                height: 100%;
                background: url($assetRoot + "/progress_bar.png") left no-repeat;
                background-size: auto 100%;
                transition: width linear .3s;
                -webkit-transition: width linear .3s;
            }
        }

        .progress-text {
            margin-top: 1rem;

            span {
                color: #FFF;
            }
        }
    }
}

.mobile {

    .lazy-cont {
        background: url($assetRoot + "/mobile/web_phone_bg.png") center no-repeat;
        background-size: 100% 100%;

        .lazy-load {

            .doctor-ani {
                min-height: 45.6vw;

                .doctor {
                    width: 60vw;
                }

                .point {
                    position: absolute;
                    width: 6vw;
                    left: 29.8vw;
                    top: 28vw;
                }
            }

            .progress-bar {
                width: 86vw;
                height: 3.6vw;
                padding: .8vw 1vw;
                margin: 1vw auto;

                .progress {
                    width: 0;
                    height: 100%;
                }
            }

            .progress-text {
                margin-top: 1vw;

                span {
                    font-size: 2rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Lazyload.vue